import { createMiddleware } from '@tanstack/react-start';
import { v4 as uuidv4 } from 'uuid';

export const requestIdMiddleware = createMiddleware({
  type: 'function',
}).server(async ({ next }) => {
  const requestId = uuidv4();
  return next({
    context: {
      requestId,
    },
  });
});
